// extracted by mini-css-extract-plugin
export default {"logoMake":"LogoMake-module__logoMake-Y2y2","small":"LogoMake-module__small-Ozab"};